var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"development"}},_vm._l((_vm.children),function(component,index){return _c(component.name,{key:index,tag:"Component",attrs:{"props":component.props}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }